'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _numberFormat = require('./mixins/number-format.mixin');

var _translation = require('./mixins/translation.mixin');

var _errorHandler = require('./mixins/error-handler.mixin');

var _dateFormat = require('./mixins/date-format.mixin');

var _environment = require('./library/environment');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Register the global error handler for vue.
_vue2.default.config.errorHandler = _errorHandler.globalVueErrorHandler;

// Register global mixins.
_vue2.default.mixin(_numberFormat.numberFormatMixin);
_vue2.default.mixin(_errorHandler.errorHandlerMixin);
_vue2.default.mixin(_translation.translationMixin);
_vue2.default.mixin(_dateFormat.dateFormatMixin);

if (!(0, _environment.isInProductionMode)()) {
    window.Vue = _vue2.default;
}

// Re-export vue
exports.default = _vue2.default;